import { useMemo } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ServiceProvidersQueries } from '@frontend/api-service-providers';
import { convertV3CalendarEventsToV2Appointments } from '@frontend/schedule-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { ExtendedAppointment } from '../../types';
import { getDateString } from '../../utils/date-helpers';

export const useGetAppointments = (startDate: string, endDate: string) => {
  const { selectedLocationIds } = useAppScopeStore();
  const { isScheduleV3FlagEnabled, isLoading: isLoadingFF } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { locationTimezoneMap } = SchedulerV3.Helpers.useScheduleLocationTimezoneShallowStore('locationTimezoneMap');

  const appointmentListV2Query = ServiceProvidersQueries.useListAppointments({
    startDate,
    endDate,
    locationIds: selectedLocationIds,
    enabled: !isScheduleV3FlagEnabled && !isLoadingFF,
  });

  // TODO: send end date as well once we add support for custom date range in widget
  const appointmentListV3Query = SchedulerV3.Helpers.useGetCalendarEventsV3Data({
    selectedDate: getDateString(startDate),
    selectedLocationIds: selectedLocationIds,
    includeOperatoryDetails: true,
  });

  const formattedAppointmentListV3Data = useMemo(() => {
    return convertV3CalendarEventsToV2Appointments(appointmentListV3Query.data?.events ?? [], locationTimezoneMap);
  }, [appointmentListV3Query.data?.events, locationTimezoneMap]);

  const isLoading = appointmentListV2Query.isFetching || appointmentListV3Query.isFetching;

  const data = (
    isScheduleV3FlagEnabled ? formattedAppointmentListV3Data : appointmentListV2Query.data?.appointments ?? []
  ) as ExtendedAppointment[];

  return { appointments: data, isLoading };
};
